import produce from 'immer';

const INITIAL_STATE = {
  token: null,
  loading: false,
  profile: null,
  logged: false,
  authError: null,
};

export default function doctor(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@doctor/SIGN_IN_REQUEST':
      case '@doctor/SIGN_IN_REQUEST_EXT': {
        draft.loading = true;
        draft.authError = null;
        break;
      }
      case '@doctor/SIGN_IN_SUCCESS': {
        draft.token = action.payload.token;
        draft.profile = action.payload.doctor;
        draft.loading = false;
        draft.logged = true;
        draft.authError = null;
        break;
      }
      case '@doctor/SIGN_FAILURE': {
        draft.loading = false;
        draft.authError = action.payload?.message || 'Erro ao fazer login!';
        break;
      }
      case '@doctor/SIGN_OUT': {
        draft.token = null;
        draft.profile = null;
        draft.logged = false;
        draft.authError = null;
        break;
      }
      default:
    }
  });
}
